<template>
  <analytics-sub-page
    title="Education Analytics"
    icon="graduation-cap"
    css-class="analytics-education"
    default-label="Education"
    :section-specs="sectionSpecs"
  >
    <coach-metrics ref="coachRef" />
  </analytics-sub-page>
</template>

<script setup>
import { ref } from 'vue';
import AnalyticsSubPage from '@/components/AnalyticsSubPage.vue';
import CoachMetrics from '@/pages/analyticsApp/components/CoachMetrics.vue';

const coachRef = ref(null);

// CoachMetrics renders four logical subsections (Coach / Education / Benefits
// Checker / Debt Advice). Each section spec scopes container capture to the
// matching `data-pdf-section` marker so the modal lists them separately and
// PDFs only include the relevant subsection.
const sectionFor = (sectionKey, hasDataKey, exportTableKey) => ({
  hasData: () => !!coachRef.value?.[hasDataKey],
  getContainerEl: () => coachRef.value?.$el?.querySelector(`[data-pdf-section="${sectionKey}"]`) || coachRef.value?.$el,
  getExportTable: () => coachRef.value?.[exportTableKey]?.() ?? null,
});

const sectionSpecs = [
  { key: 'coach', label: 'Coach', ...sectionFor('coach', 'hasCoachData', 'getCoachExportTable') },
  { key: 'education', label: 'Education', ...sectionFor('education', 'hasEducationData', 'getEducationExportTable') },
  {
    key: 'benefits-checker',
    label: 'Benefits Checker',
    ...sectionFor('benefits-checker', 'hasBenefitsData', 'getBenefitsExportTable'),
  },
  { key: 'debt-advice', label: 'Debt Advice', ...sectionFor('debt-advice', 'hasDebtData', 'getDebtExportTable') },
];
</script>
